<template>
  <div className="logo">
    <span role="img">📹</span>
    <h1>enjoyMovie</h1>
  </div>
</template>
